import InlineStyles from "@/components/InlineStyles";
import LauncherProvider from "./lib/client/contexts/LauncherContext";
import { DarkModeProvider } from "@/lib/client/contexts/DarkModeContext";
import AppContainer from "./components/AppContainer";
import { LauncherStoreProvider } from "./lib/client/contexts/LauncherStoreContext";
import type {
  MessengerConfig,
  UrlCacheableConfig,
} from "@deskpro-product/messenger-api-schemas/messenger/config";
import type { BasePath } from "./[locale]/lib/types/routeTypes";

export default function LauncherLayout({
  params,
  config,
  basePath,
  mediaBaseUrl,
  platform,
  children,
}: {
  params: { tenantId: string; messengerId: string; hostConfig: string };
  config: MessengerConfig;
  basePath: BasePath;
  mediaBaseUrl: string;
  platform: NonNullable<UrlCacheableConfig["platform"]>;
  children: React.ReactNode;
}) {
  return (
    <LauncherStoreProvider>
      <LauncherProvider
        tenantId={params.tenantId}
        messengerId={params.messengerId}
        hostConfig={params.hostConfig}
        mediaBaseUrl={mediaBaseUrl}
        config={config}
        basePath={basePath}
        platform={platform}
      >
        <DarkModeProvider>
          <InlineStyles />
          <AppContainer>{children}</AppContainer>
        </DarkModeProvider>
      </LauncherProvider>
    </LauncherStoreProvider>
  );
}
